/** Same cutoff as servicing-login: 4 minutes 55 seconds. */
export const CLOCK_SKEW_LIMIT_MS = 295_000;

function formatTimeIso(ms: number): string | null {
  if (!Number.isFinite(ms)) return null;
  return new Date(ms).toISOString();
}

/**
 * True when the device clock is more than CLOCK_SKEW_LIMIT_MS away from the
 * server clock. Mirrors servicing-login's msLocalServerDiff > 295000 check.
 * An invalid/non-positive server time never reports out-of-sync.
 */
export function isDeviceClockOutOfSync(serverTimeMs: number, now = Date.now()): boolean {
  const invalidServerTime = !Number.isFinite(serverTimeMs) || serverTimeMs <= 0;
  const signedSkewMs = invalidServerTime ? null : now - serverTimeMs;
  const absoluteSkewMs = signedSkewMs === null ? null : Math.abs(signedSkewMs);
  const outOfSync = absoluteSkewMs !== null && absoluteSkewMs > CLOCK_SKEW_LIMIT_MS;
  const reason = invalidServerTime ? "invalid-server-time" : outOfSync ? "exceeds-limit" : "within-limit";

  console.log("[AUTH FLOW] Device clock check", {
    serverTimeMs,
    deviceTimeMs: now,
    serverTimeIso: formatTimeIso(serverTimeMs),
    deviceTimeIso: formatTimeIso(now),
    signedSkewMs,
    absoluteSkewMs,
    limitMs: CLOCK_SKEW_LIMIT_MS,
    outOfSync,
    reason,
  });

  return outOfSync;
}
